import AsyncProcesses from './AsyncProcesses';
import Page from './Page';
import Form from './Form';
import Calendar from './Calendar';
import Search from './Search';
import { init } from './GoogleAnalytics';

var DynamicQueryApi = (function () {

    var internalGet = function (url) {
        return $.ajax({
            type: 'GET',
            contentType: 'application/json',
            dataType: 'json',
            url: url,
            cache: false,
            async: true
        });
    };

    var internalPost = function (url, data) {
        return $.ajax({
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            url: url,
            data: JSON.stringify(data),
            cache: false,
            async: true
        });
    };

    var internalGetFilters = function (dynamicQueryId) {
        return internalGet(Page.getApplicationPath() + 'api/v1/frontend/dynamicquery/' + dynamicQueryId + '/filters');
    };

    var internalGetOutputs = function (dynamicQueryId) {
        return internalGet(Page.getApplicationPath() + 'api/v1/frontend/dynamicquery/' + dynamicQueryId + '/outputs');
    };

    var internalPostGenerationPromise = function (dynamicQueryId, data) {
        return internalPost(Page.getApplicationPath() + 'api/v1/frontend/dynamicquery/' + dynamicQueryId, data);
    };

    var internalGetCubeUrl = function (dynamicQueryId) {
        return Page.getApplicationPath() + 'api/v1/frontend/dynamicquery/' + dynamicQueryId + '/cube';
    };

    return {
        getFiltersPromise: internalGetFilters,
        getOutputsPromise: internalGetOutputs,
        postGenerationPromise: internalPostGenerationPromise,
        getCubeUrl: internalGetCubeUrl
    };

})();

var DynamicQueryIds = {
    OutputsPlaceholderSelector: '#OutputsPlaceholder',
    OutputAreaSelector: '#DynamicQueryOutput',
    PendingExecutionsSelector: '.row-message-execute',
    FiltersPlaceholderSelector: '#FiltersPlaceholder',
    ErrorPlaceholderSelector: '#ErrorPlaceholder'
};

var DynamicQueryFilters = (function () {

    const notImplementedHtml = '<div class="col-md-4 col-sm-4 value">Não implementado</div>';

    var getLabel = function (filter) {
        var html = '<label class="control-label col-md-2 col-sm-2"><div class="label-form"><div class="label-title">' + filter.title;
        if (filter.isRequired) {
            html += '<div class="label-title-required"><span class="required" aria-required="true"> * </span></div>';
        }
        html += '</div></div></label>';
        return html;
    }

    var renderLookupSingleFilter = function (filter) {
        if (filter.template) {
            return '<div class="col-md-4 col-sm-4 value">' + filter.template + '</div>';
        }
        return notImplementedHtml;
    };

    var renderLookupMultipleFilter = function (filter) {
        if (filter.template) {
            return '<div class="col-md-4 col-sm-4 value">' + filter.template + '</div>';
        }
        return notImplementedHtml;
    };

    var renderDateFilter = function (filter) {
        var html = '<div class="col-md-4 col-sm-4 value">';
        html += '<div class="row">';
        html += '<div class="col-md-5">';
        html += '<div class="input-group">';
        html += '<input class="datepicker form-control" name="' + filter.id + '" data-name="' + filter.id + '" type="text" data-type="date" data-clear-btn="true" maxlength="10" placeholder="dd/mm/aaaa" data-date-format="dd/mm/yyyy"><span class="input-group-btn"><button class="btn btn-default btn-sm" type="button"><i class="fa fa-calendar"></i></button></span>';
        html += '</div></div></div></div>';
        return html;
    };

    var renderDateRangeFilter = function (filter) {
        var html = '<div class="col-md-4 col-sm-4 value">';
        html += '<div class="row">';
        html += '<div class="col-md-5">';
        html += '<div class="input-group">';
        html += '<input class="datepicker form-control" name="' + filter.id + '_DE" data-name="' + filter.id + '_DE" type="text" data-type="date" data-clear-btn="true" maxlength="10" placeholder="dd/mm/aaaa" data-date-format="dd/mm/yyyy"><span class="input-group-btn"><button class="btn btn-default btn-sm" type="button"><i class="fa fa-calendar"></i></button></span>';
        html += '</div>';
        html += '</div><div class="col-md-2">';
        html += '<label class="control-label col-md-2 col-sm-2"><div class="label-form"><div class="label-title">até</div></div></label>';
        html += '</div><div class="col-md-5">';
        html += '<div class="input-group">';
        html += '<input class="date datepicker form-control" name="' + filter.id + '_ATE" data-name="' + filter.id + '_ATE" type="text" data-type="date" data-clear-btn="true" maxlength="10" placeholder="dd/mm/aaaa" data-date-format="dd/mm/yyyy"><span class="input-group-btn"><button class="btn btn-default btn-sm" type="button"><i class="fa fa-calendar"></i></button></span>';
        html += '</div>';
        html += '</div>';
        html += '</div></div>';
        return html;

    };

    var renderMonthRangeFilter = function (filter) {
        var html = '<div class="col-md-4 col-sm-4 value">';
        html += '<div class="row">';
        html += '<div class="col-md-5">';
        html += '<div class="input-group">';
        html += '<input class="datepicker form-control" name="' + filter.id + '_DE" data-name="' + filter.id + '_DE" type="text" data-type="date" data-clear-btn="true" maxlength="7" placeholder="mm/aaaa" data-date-format="mm/yyyy"><span class="input-group-btn"><button class="btn btn-default btn-sm" type="button"><i class="fa fa-calendar"></i></button></span>';
        html += '</div>';
        html += '</div><div class="col-md-2">';
        html += '<label class="control-label col-md-2 col-sm-2"><div class="label-form"><div class="label-title">até</div></div></label>';
        html += '</div><div class="col-md-5">';
        html += '<div class="input-group">';
        html += '<input class="date datepicker form-control" name="' + filter.id + '_ATE" data-name="' + filter.id + '_ATE" type="text" data-type="date" data-clear-btn="true" maxlength="7" placeholder="mm/aaaa" data-date-format="mm/yyyy"><span class="input-group-btn"><button class="btn btn-default btn-sm" type="button"><i class="fa fa-calendar"></i></button></span>';
        html += '</div>';
        html += '</div>';
        html += '</div></div>';
        return html;
    };

    var renderRadioFilter = function (filter) {
        var html = '<div class="col-md-4 col-sm-4 value">';
        html += '<div class="mt-radio-inline" name="' + filter.id + '" data-name="' + filter.id + '" data-toggle="radio">';
        filter.items.forEach(function (item) {
            html += '<label class="mt-radio mt-radio-outline">';
            html += '<input class="toggle" type="radio" name="' + filter.id + '" value="' + item.id + '">' + item.text + '<span></span></label>';
        });
        html += '</div></div>';
        return html;
    };

    var renderSelectionFilter = function (filter) {
        var html = '<div class="col-md-4 col-sm-4 value">';
        html += '<div class="input-group select2-bootstrap-append">';
        html += '<select class="filter-select-multiple form-control input-sm" name="' + filter.id + '" data-name="' + filter.id + '" >';
        filter.items.forEach(function (item) {
            html += '<option value="' + item.id + '">' + item.text + '</option>';
        });
        html += '</select>';
        html += '<span class="input-group-btn"></span>';
        html += '</div></div>';
        return html;
    };

    var renderTextFilter = function (filter) {
        var html = '<div class="col-md-4 col-sm-4 value">';
        html += '<input class="form-control" type="text" name="' + filter.id + '" data-name="' + filter.id + '" data-type="string" value="' + filter.value + '">';
        html += '</div>';
        return html;
    };


    var renderNumericRangeFilter = function (filter, decimalPlaces) {
        var html = '<div class="col-md-4 col-sm-4 value">';
        html += '<div class="row">';
        html += '<div class="col-md-5">';
        html += '<input class="form-control auto-numeric" name="' + filter.id + '_DE" data-name="' + filter.id + '_DE" type="text" data-type="number" data-decimalplaces="' + decimalPlaces + '" data-decimalcharacter="," data-digitgroupseparator="" data-minimumvalue="-999999999999." data-maximumvalue="999999999999." onchange="" value="">';
        html += '</div><div class="col-md-2">';
        html += '<label class="control-label col-md-2 col-sm-2"><div class="label-form"><div class="label-title">até</div></div></label>';
        html += '</div><div class="col-md-5">';
        html += '<input class="form-control auto-numeric" name="' + filter.id + '_ATE" data-name="' + filter.id + '_ATE" type="text" data-type="number" data-decimalplaces="' + decimalPlaces + '" data-decimalcharacter="," data-digitgroupseparator="" data-minimumvalue="-999999999999." data-maximumvalue="999999999999." onchange="" value="">';
        html += '</div>';
        html += '</div></div>';
        return html;
    };

    var renderIntegerRangeFilter = function (filter) {
        return renderNumericRangeFilter(filter, 0);
    };

    var renderCurrencyRangeFilter = function (filter) {
        return renderNumericRangeFilter(filter, 2);
    };

    var internalRender = function (filters) {

        var html = '';
        var closing = ''
        filters.forEach(function (filter, index) {
            if (index % 2 == 0) {
                html += closing;
                html += '<div class="form-group">';
                closing = '</div>'
            }

            html += getLabel(filter);

            if (filter.filterType == "lookup_single") {
                html += renderLookupSingleFilter(filter);
            } else if (filter.filterType == "lookup_multiple") {
                html += renderLookupMultipleFilter(filter);
            } else if (filter.filterType == "date") {
                html += renderDateFilter(filter);
            } else if (filter.filterType == "date_range") {
                html += renderDateRangeFilter(filter);
            } else if (filter.filterType == "month_range") {
                html += renderMonthRangeFilter(filter);
            } else if (filter.filterType == "radio") {
                html += renderRadioFilter(filter);
            } else if (filter.filterType == "selection") {
                html += renderSelectionFilter(filter);
            } else if (filter.filterType == "text") {
                html += renderTextFilter(filter);
            } else if (filter.filterType == "integer_range") {
                html += renderIntegerRangeFilter(filter);
            } else if (filter.filterType == "currency_range") {
                html += renderCurrencyRangeFilter(filter);
            } else {
                html += 'Tipo de filtro desconhecido: ' + filter.filterType;
            }
        });

        html += closing;

        $(DynamicQueryIds.FiltersPlaceholderSelector).html(html);
        Form.init();
        Search.init();
        Calendar.init();

        $(".filter-select-multiple").val([]).select2({ multiple: true, closeOnSelect: false, allowClear: true, placeholder: 'Selecione os itens' });
    };

    var internalGetValues = function () {
        var values = [];
        $(DynamicQueryIds.FiltersPlaceholderSelector).find('input,select').map(function () {
            var element = $(this);
            var name = element.data('name') || element.data('fieldname');
            if (!name) {
                return;
            }
            var value = element.val() || "";
            if (Array.isArray(value)) {
                value = value.join(',');
            }

            if (value) {
                values.push({ name: name, value: value });
            }
        });

        return values;
    };

    var internalClearFilters = function () {
        $(DynamicQueryIds.FiltersPlaceholderSelector).find('select[multiple]').val([]).trigger('change');
        $(DynamicQueryIds.FiltersPlaceholderSelector).find('select:not([multiple])').val(null).trigger('change');
        $(DynamicQueryIds.FiltersPlaceholderSelector).find('input[data-name]').val('');
    };

    return {
        render: internalRender,
        getValues: internalGetValues,
        clearFilters: internalClearFilters
    };

})();

var DynamicQueryOutput = (function () {

    var cubeInitialized = false;

    var internalGetSqlHtml = function (payload) {

        var html = '';
        html += '<style>';
        html += '.sql-text { width: 100%; height: 300px; }';
        html += '</style>';
        html += '<div class="tabbable-line" style="margin: 40px 5px 40px 5px">';
        html += '<ul class="nav nav-tabs">';
        html += '<li class="active"><a href="#tabCompleto" data-toggle="tab" aria-expanded="true"> Completo </a></li>';
        html += '<li class=""><a href="#tabOriginal" data-toggle="tab" aria-expanded="false"> Original </a></li>';
        html += '<li class=""><a href="#tabParametros" data-toggle="tab" aria-expanded="false"> Parâmetros </a></li>';
        html += '</ul>';
        html += '<div class="tab-content">';
        html += '<div class="tab-pane fade active in" id="tabCompleto">';
        html += '<textarea readonly="" class="sql-text">' + payload.full + '</textarea>';
        html += '</div>';
        html += '<div class="tab-pane fade" id="tabOriginal">';
        html += '<textarea readonly="" class="sql-text">' + payload.original + '</textarea>';
        html += '</div>';
        html += '<div class="tab-pane fade" id="tabParametros">';
        html += '<ul>';
        for (var i = 0; i < payload.parameters.length; i++) {
            var param = payload.parameters[i];
            html += '<li>' + param.name + ' = ' + param.value + '</li>';
        }
        html += '</ul>';
        html += '</div>';
        html += '</div>';
        html += '</div>';
        return html;
    };

    var internalGetDatasetHtml = function (payload) {
        var html = '';
        html += '<div class="table-responsive table-scrollable">';
        html += '<table class="table table-hover simple-grid" cellspacing="0" border="0" style="border-collapse:collapse;">';
        html += '<thead><tr>';
        payload.headers.forEach(function (header) {
            html += '<th class="text-left normal-white-space" scope="col">' + header.text + '</th>';
        });
        html += '</tr></thead>';
        html += '<tbody>';
        payload.rows.forEach(function (row) {
            html += '<tr class="no-selected">';
            row.forEach(function (cell) {
                html += '<td class="text-left normal-white-space">' + cell.text + '</td>';
            });
            html += '</tr>';
        });

        if (payload.summary && payload.summary.length > 0) {
            html += '<tr class="no-selected">';
            payload.summary.forEach(function (cell) {
                html += '<td class="text-left normal-white-space" scope="col">' + cell.text + '</td>';
            });
            html += '</tr>';
        }

        html += '</tbody>';
        html += '</table>';
        html += '</div>';
        html += '<div class="row grid-footer-row dataTables_wrapper">';
        html += '<div class="col-md-12">';
        html += '<div class="dataTables_paginate paging_simple_numbers">';
        html += '<ul class="pagination">';
        html += '<li class="paginate_button previous " tabindex="0">';
        let href = payload.pageIndex <= 0 ? 'void(0)' : 'Benner.DynamicQueryGenerator.navigate(' + (payload.pageIndex - 1) + ')';
        html += '<a href="javascript:' + href + '"><i class="fa fa-angle-left"></i></a>';
        html += '</li>';
        html += '<li class="paginate_button next " tabindex="0">';
        href = payload.morePages ? 'Benner.DynamicQueryGenerator.navigate(' + (payload.pageIndex + 1) + ')' : 'void(0)';
        html += '<a href="javascript:' + href + '"><i class="fa fa-angle-right"></i></a>';
        html += '</li>';
        html += '</ul>';
        html += '</div>';
        html += '</div>';
        html += '</div>';

        return html;
    };

    var internalGetMessageHtml = function (payload) {
        if (payload) {
            // replace line breaks with <br> for HTML display
            payload = payload.replace(/(\r\n|\n|\r)/gm, '<br/>');
        }
        return '<div class="alert alert-info">' + payload + '</div>';
    };

    var internalGetTaskHtml = function (payload) {
        return '<div class="alert alert-info">Processo de geração de arquivo iniciado.<div>';
    };

    var internalGetCubeHtml = function (payload) {
        var html = '<div id="VISUALIZACAOCUBO" class="col-md-12 widget  portlet-default" widget-type="PivotTable" aria-expanded="true" widget-uniqueid="VISUALIZACAOCUBO" widget-jsproperties="JTdiJTdk" >';
        html += '<div class="portlet light" id="portlet_VISUALIZACAOCUBO">';
        html += '<div class="portlet-body form">';
        html += '<div class="widget-body" data-widget-id="VISUALIZACAOCUBO">';
        html += '<div id="VISUALIZACAOCUBO_UpdatePanel" class="update-panel" style="">';
        html += '<div id="VISUALIZACAOCUBO_CONTENT" class="pivot-table-content"> </div>';
        html += '</div></div></div></div></div>';
        return html;
    };


    var internalShow = function (id, content) {
        var html;
        var initHtml = null;
        if (content.format == 'sql') {
            html = internalGetSqlHtml(content.payload);
        } else if (content.format == 'dataset') {
            html = internalGetDatasetHtml(content.payload);
        } else if (content.format == 'message') {
            html = internalGetMessageHtml(content.payload);
        } else if (content.format == 'task') {
            html = internalGetTaskHtml(content.payload);
            Benner.AsyncProcesses.getAsyncProcesses();
        } else if (content.format == 'cube') {
            html = internalGetCubeHtml(content.payload);
            initHtml = function () {
                var sessionKey = "PivotTable_" + String(Benner.Page.userName) + "_" + id;
                if (!cubeInitialized) {
                    // delete local storage state to force reloading the cube
                    if (localStorage) {
                        localStorage.removeItem(sessionKey);
                    }
                    cubeInitialized = true;
                }

                // inicializar o cubo aqui
                Benner.PivotTable.init(
                    // Url
                    DynamicQueryApi.getCubeUrl(id),
                    // ID da div
                    'VISUALIZACAOCUBO_CONTENT',
                    // Altura do widget, deve ser altura do browser menos 250px
                    $(window).height() - 250,
                    // Chave para armazenamento do estado do cubo
                    sessionKey,
                    // Mostrar ou não mostrar áreas de campos de linha, coluna e valor
                    false,
                    // Nome para arquivo excel
                    'Cubo',
                    // Estado
                    content.payload);
            };
        } else {
            html = 'Formato de saída desconhecido: ' + content.format;
        }

        $(DynamicQueryIds.PendingExecutionsSelector).hide();

        var target = $(DynamicQueryIds.OutputAreaSelector);
        target.empty();
        target.append(html);

        if (initHtml) {
            initHtml();
        };
    };

    return {
        show: internalShow
    };
})();

var DynamicQueryGenerator = (function () {

    var blockUI = function () {
        App.blockUI({ target: $(".dynamic-query-area"), animate: true });
    };

    var unblockUI = function () {
        App.unblockUI($(".dynamic-query-area"));
    };

    var getCurrentId = function () {
        return $("#DynamicQueryId").val();
    };

    var internalGetFilters = function () {
        var id = getCurrentId();

        blockUI();

        DynamicQueryApi.getFiltersPromise(id)
            .done(function (data) {
                DynamicQueryFilters.render(data.content.filters);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                setErrorMessage("Erro ao retornar os filtros. Verifique o console para mais detalhes.");
                console.log(textStatus, errorThrown);
            }).always(function () {
                unblockUI();
            });
    };

    var internalGetOutputs = function () {
        var id = getCurrentId();

        DynamicQueryApi.getOutputsPromise(id)
            .done(function (data) {
                var html = '';
                data.content.outputs.forEach(function (output) {
                    html += '<button class="btn command-action custom-action btn-primary btn-dynamic-query-generation" type="button" onclick="Benner.DynamicQueryGenerator.generate(this)" data-output-id="' + output.id + '" ><i class="' + output.icon + '"></i>&nbsp;' + output.title + '</button>';
                });
                $(DynamicQueryIds.OutputsPlaceholderSelector).html(html);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                $(DynamicQueryIds.OutputsPlaceholder).html("<div>Não foi possível obter as saídas disponíveis. Para mais informações verifique o console.</div>");
                console.log(textStatus, errorThrown);
            });
    };


    var internalInit = function () {
        internalGetFilters();
        internalGetOutputs();
    };

    var setErrorMessage = function (message) {
        let target = $(DynamicQueryIds.ErrorPlaceholderSelector);
        if (message) {
            var formatedMessage = message.replace(/(\r\n|\n|\r)/gm, '<br/>');
            target.html('<div class="alert alert-danger">' + formatedMessage + '</div>');
        } else {
            target.empty();
        }
    };


    var internalRequest = function (outputId, pageIndex) {

        var id = getCurrentId();

        var filters = DynamicQueryFilters.getValues();

        var data = {
            outputId: outputId,
            filters: filters,
            pageIndex: pageIndex
        };

        blockUI();

        DynamicQueryApi.postGenerationPromise(id, data)
            .done(function (data) {
                DynamicQueryOutput.show(id, data.content);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.responseJSON && jqXHR.responseJSON.Message) {
                    setErrorMessage(jqXHR.responseJSON.Message);
                } else {
                    console.log(textStatus, errorThrown);
                    setErrorMessage("Ocorreu um erro ao gerar. Verifique o console para mais detalhes.");
                }
            }).always(function () {
                unblockUI();
            });
    };

    var internalGenerate = function (outputElement) {
        var outputId = $(outputElement).data("output-id");
        internalRequest(outputId, 0);
    };

    var internalNavigate = function (pageIndex) {
        var outputId = "grid";
        internalRequest(outputId, pageIndex);
    };

    var internalClearFilters = function () {
        DynamicQueryFilters.clearFilters();
    };

    return {
        init: internalInit,
        generate: internalGenerate,
        navigate: internalNavigate,
        clearFilters: internalClearFilters
    };
})();

export default DynamicQueryGenerator;